"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const BannerAction_1 = __importDefault(require("../promotion-banner/subcomponents/BannerAction/BannerAction"));
const BannerBase_module_scss_1 = __importDefault(require("./BannerBase.module.scss"));
const BannerBase = ({ messageDesktop, messageDesktopClassName, messagePrefixConfig, theme = 'blue', action, actionText, actionTextClassName, className, contentClassName, dataSelector, desktopMessageDataSelector, sitewidePromo }) => {
    if (!messageDesktop) {
        return null;
    }
    const classes = (0, classnames_1.default)(BannerBase_module_scss_1.default.bannerBase, {
        [BannerBase_module_scss_1.default[`bannerBase--${theme}`]]: !!theme
    }, className);
    const innerContainerClasses = (0, classnames_1.default)('container', BannerBase_module_scss_1.default.content, contentClassName);
    return ((0, jsx_runtime_1.jsx)("div", { className: classes, "data-selector": dataSelector, "aria-label": 'Sale', children: (0, jsx_runtime_1.jsx)("div", { className: innerContainerClasses, children: (0, jsx_runtime_1.jsxs)("div", { children: [messagePrefixConfig &&
                        (0, jsx_runtime_1.jsx)("span", { className: messagePrefixConfig.isBold && 't-bold', dangerouslySetInnerHTML: { __html: `${messagePrefixConfig.prefix} ` } }), (0, jsx_runtime_1.jsx)("span", { className: messageDesktopClassName, "data-selector": desktopMessageDataSelector, dangerouslySetInnerHTML: { __html: messageDesktop } }), action &&
                        (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["\u00A0|\u00A0", (0, jsx_runtime_1.jsx)(BannerAction_1.default, { action: action, actionText: actionText, theme: theme, sitewidePromo: sitewidePromo, actionTextClassName: BannerBase_module_scss_1.default[actionTextClassName] })] })] }) }) }));
};
BannerBase.propTypes = {
    messageDesktop: prop_types_1.default.string,
    messageDesktopClassName: prop_types_1.default.string,
    messageMobileClassName: prop_types_1.default.string,
    messagePrefixConfig: prop_types_1.default.shape({
        id: prop_types_1.default.string,
        prefix: prop_types_1.default.string,
        isBold: prop_types_1.default.bool
    }),
    theme: prop_types_1.default.string,
    action: prop_types_1.default.string,
    actionText: prop_types_1.default.string,
    actionTextClassName: prop_types_1.default.string,
    className: prop_types_1.default.string,
    contentClassName: prop_types_1.default.string,
    dataSelector: prop_types_1.default.string,
    desktopMessageDataSelector: prop_types_1.default.string
};
exports.default = BannerBase;
//# sourceMappingURL=BannerBase.js.map